/**
 * Selects the logged-in user's username from the Redux state.
 * @param {Object} state - The Redux state.
 * @returns {string|undefined} The username of the logged-in user, or undefined if not available.
 */
export const loggedInUserUsernameSelector = ({ account }) => account?.data?.Username;
/**
 * Selects the list of users from the Redux state.
 * @param {Object} state - The Redux state.
 * @returns {Array|undefined} The list of users, or undefined if not available.
 */
export const usersListSelector = ({ users }) => users.usersList;
/**
 * Selects the current request status for users from the Redux state.
 * @param {Object} state - The Redux state.
 * @returns {string|undefined} The request status, or undefined if not available.
 */
export const requestStatusSelector = ({ users }) => users?.requestStatus;
/**
 * Selects the current request status message for users from the Redux state.
 * @param {Object} state - The Redux state.
 * @returns {string|undefined} The request status message, or undefined if not available.
 */
export const requestStatusMessageSelector = ({ users }) => users?.requestStatusMessage;
/**
 * Selects the loading state for users from the Redux state.
 * @param {Object} state - The Redux state.
 * @returns {boolean|undefined} True if loading, false if not, or undefined if not available.
 */
export const isLoadingSelector = ({ users }) => users?.isLoading;
/**
 * Selects the details of the selected user from the Redux state.
 * @param {Object} state - The Redux state.
 * @returns {Object|undefined} The selected user's details, or undefined if not available.
 */
export const selectedUserDetailsSelector = ({ users }) => users?.selectedUserDetails;
/**
 * Selects the selected user from the Redux state.
 * @param {Object} state - The Redux state.
 * @returns {Object|undefined} The selected user, or undefined if not available.
 */
export const selectedUserSelector = ({ users }) => users?.selectedUser;
/**
 * Selects the permission role primary key (PK_PermissionRole) for the logged-in user from the Redux state.
 * @param {Object} state - The Redux state.
 * @returns {number|undefined} The user's permission role code, or undefined if not available.
 */
export const accountPK_PermissionRoleSelector = ({ account }) => account?.data?.PK_PermissionRole;
